import React, { CSSProperties, ReactElement } from 'react';

export interface DividerProps {
  size?: number;
  withBorder?: boolean;
  style?: CSSProperties;
}

export const Divider = ({
  size = 15,
  withBorder = false,
  style = {},
}: DividerProps): ReactElement => {
  const border = withBorder ? '1px solid #e3e3e3' : 'none';

  return (
    <hr
      style={{
        width: '100%',
        height: size,
        backgroundColor: '#f0f0f0',
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: border,
        borderBottom: border,
        margin: 0,
        ...style,
      }}
    />
  );
};
